"use client";
import { j as e } from "./index.es73.js";
import { forwardRef as n, useMemo as h } from "react";
import { makeUniqueId as m } from "./index.es139.js";
const b = n(
  ({ label: a, isChecked: d, onChange: i, isDefaultChecked: r, isDisabled: c, inputId: o, ...l }, t) => {
    const s = h(() => m(), []);
    return /* @__PURE__ */ e.jsxs("div", { className: "bl-checkbox", children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          ...l,
          ref: t,
          onChange: i,
          type: "checkbox",
          id: o || s,
          defaultChecked: r,
          disabled: c,
          checked: d
        }
      ),
      /* @__PURE__ */ e.jsx("label", { htmlFor: o || s, children: a })
    ] });
  }
);
export {
  b as default
};
//# sourceMappingURL=index.es74.js.map
